import { AdSlot } from '@/types/views/generic';

export type AdSlotsConfigProps = Record<
  AdSlot,
  {
    container: string;
    width?: number | string;
    height?: number;
    minHeight?: number;
  }
>;

const AdSlotsConfig: AdSlotsConfigProps = {
  'side-right_ad_1': {
    container: 'ad-slot-side-right_ad_1',
    width: 300,
    height: 600,
    minHeight: 250,
  },
  right_ad_1: {
    container: 'ad-slot-right_ad_1',
    width: 300,
    height: 600,
  },
  left_ad_1: {
    container: 'ad-slot-left_ad_1',
    width: 300,
    height: 600,
  },
  top_special_1: {
    container: 'ad-slot-top_special_1',
  },
  top_ad_1: {
    container: 'ad-slot-top_ad_1',
    width: '100%',
    height: 250,
    minHeight: 50,
  },
  index_ad_1: {
    container: 'ad-slot-index_ad_1',
    width: '100%',
    height: 250,
    minHeight: 50,
  },
  index_ad_2: {
    container: 'ad-slot-index_ad_2',
    width: '100%',
    height: 250,
  },
  bottom_ad_1: {
    container: 'ad-slot-bottom_ad_1',
    width: '100%',
    height: 250,
    minHeight: 50,
  },
  preroll_1: {
    container: 'ad-slot-preroll_1',
    width: 0,
    height: 0,
  },
};

export default AdSlotsConfig;
